import { baseResources, baseResourceActions } from "routes/enum";

const {
    AGENTS_INBOX_BASE_SETTING,
    TICKET_CLASSIFICATION,
    AGENTS_INBOX_TEAM,
    AGENTS_INBOX_TEAM_MEMBER,
    TICKET_ROUTING,
} = baseResources;

const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View agent inbox settings */
export const INBOX_SETTINGS_READ_PERMISSION = [
    `${READ}_${AGENTS_INBOX_BASE_SETTING}`,
];

/** Add new ticket classification */
export const CLASSIFICATION_CREATE_PERMISSION = [
    `${CREATE}_${TICKET_CLASSIFICATION}`,
];

/** Create new team */
export const TEAM_CREATE_PERMISSION = [`${CREATE}_${AGENTS_INBOX_TEAM}`];

/** Delete team */
export const TEAM_DELETE_PERMISSION = [`${DELETE}_${AGENTS_INBOX_TEAM}`];

/** Remove team members */
export const TEAM_MEMBER_DELETE_PERMISSION = [
    `${DELETE}_${AGENTS_INBOX_TEAM_MEMBER}`,
];

/** Turn on/off ticket routing */
export const TICKET_ROUTING_UPDATE_PERMISSION = [`${UPDATE}_${TICKET_ROUTING}`];

export const TICKET_ROUTING_PERMISSION_MAP = {
    "View agent inbox settings": INBOX_SETTINGS_READ_PERMISSION,
    "Add new ticket classification": CLASSIFICATION_CREATE_PERMISSION,
    "Create new team": TEAM_CREATE_PERMISSION,
    "Delete team": TEAM_DELETE_PERMISSION,
    "Remove team members": TEAM_MEMBER_DELETE_PERMISSION,
    "Turn on/off ticket routing": TICKET_ROUTING_UPDATE_PERMISSION,
};
